import React from 'react';
const image = (props) => {
    return (
        <img style={{ width: '100%', ...props.style }} src={props.src} alt={props.alt} />
    )
}
export default image;